import {type IdToken, useAuth0} from '@auth0/auth0-react';
import SignInView from 'containers/views/globalViews/SignInView';
import {useEffect, useState} from 'react';

export const ProtectedRoute = ({children}) => {
  const {isAuthenticated, getIdTokenClaims} = useAuth0();
  const [claims, setClaims] = useState<IdToken | undefined>(undefined);

  useEffect(() => {
    void getIdTokenClaims().then((claims) => {
      setClaims(claims);
    });
  }, [claims, isAuthenticated]);

  if (!claims && !isAuthenticated) {
    return <SignInView />;
  }

  return children;
};
